import { Client } from "../client"
import { getMe } from "../selectors/entities/users";


export function login(params) {
    return async function (dispatch, getState) {
        let data = null;
        dispatch({
            type: 'USER_LOGIN_REQUEST'
        })
        try {
            data = await Client.login(params)
        } catch (err) {
            dispatch({
                type: 'USER_FETCH_FAILED',
                err,
            })
        }
        dispatch(
            {
                type: 'USER_LOGIN_SUCCESS',
                data,
            },
            getState()
        )
        return data;
    }
}


export function logout(params) {
    return async function (dispatch, getState) {
        const me = getMe(getState())
        const needLogout = (params.email === me.email);
        if (needLogout) {
            dispatch({
                type: 'USER_LOGOUT_SUCCESS'
            })
        }
        return needLogout;
    }
}

export function externalLogin(params) {
    return async function (dispatch, getState) {
        if (params.email) {
            dispatch({
                type: 'USER_LOGIN_EXTERNAL_SUCCESS'
            })
        }
        return true;
    }
}

export function getDetails(params) {
    return async function (dispatch, getState) {
        let data = null;
        dispatch({
            type: 'USER_DETAILS_REQUEST'
        })
        try {
            data = await Client.getShirtDetails(params)
        } catch (err) {
            dispatch({
                type: 'USER_FETCH_FAILED',
                err,
            })
        }
        if (data && data.error_id) {
            dispatch({
                type: 'UPDATE_REQUEST_ERROR',
                data,
                errorMessage: data.error_message
            }, getState())
        }
        if (data && data.objectId) {
            dispatch({
                type: 'USER_LOGIN_SUCCESS',
                data,
            }, getState())
        }
        return data;
    }
}